import React, { useContext, useCallback } from 'react';
import {
    Grid,
    GridColumn,
    Text,
    View,
    ThemeProvider,
    Icon,
    colors,
} from '@fairygodboss/ui';
import { JobContext } from '../../../../../../contexts/ContextCreator';
import { determineJobLikedStatus } from '../../../SingleJobTemplateV2/SingleJobTemplateV2';
import { ApplyButtonGroup } from '../../../SingleJobTemplateV2/ApplyButtonGroup';

const StyledText = ({ text }) => (
    <Text variant="bodyMd" fontWeight="600" lineHeight="18px" as="div">
        {text}
    </Text>
);

export const Company = ({ companyName, rating, locationName }) => (
    <View display="flex" flexDirection="unset" flexWrap="wrap">
        <Text
            variant="bodyMd"
            fontWeight="600"
            lineHeight="18px"
            as="div"
            data-qa="sticky-company"
            width="max-content"
            mr="16px"
        >
            {companyName}
        </Text>

        <View display="flex" ml="10px" width="max-content">
            {rating ? (
                <>
                    <Icon
                        mr="6px"
                        variant="ratingWingFilled_20"
                        outlineColor={colors.primary[60]}
                    />
                    <StyledText text={rating} />
                </>
            ) : undefined}
            &nbsp; <StyledText text="|" /> &nbsp;{' '}
        </View>

        <StyledText
            text={
                <View
                    as="span"
                    data-qa="sticky-company"
                >{`${locationName}`}</View>
            }
        />
    </View>
);

const StickyCompanyHeaderV2 = ({
    visible,
    company,
    jobDetails,
    handleCompanyApplyClick,
    isInternalSticky,
    saveButtonText,
    applyButtonText,
    onJobSaveClick,
    userLiked,
}) => {
    const { companyName, rating } = company;
    const { title, locationName, slug } = jobDetails;

    const jobContext = useContext(JobContext);

    const { toggleJobLike, content } = jobContext;
    const isSaved = onJobSaveClick
        ? userLiked
        : determineJobLikedStatus(slug, content);

    const handleSaveClick = useCallback(() => {
        if (onJobSaveClick) {
            onJobSaveClick({ userLiked, hash: slug });
            return;
        }
        toggleJobLike(slug);
    }, [toggleJobLike, slug, onJobSaveClick, userLiked]);

    if (!visible) {
        return null;
    }

    return (
        <ThemeProvider>
            <View
                display={{ _: 'none', md: 'block' }}
                width={isInternalSticky ? '58.4%' : '100%'}
                backgroundColor="white"
                pt={isInternalSticky ? '16px' : '27px'}
                pb={isInternalSticky ? '16px' : '26px'}
                position={isInternalSticky ? 'absolute' : 'fixed'}
                top={isInternalSticky ? '0px' : '56px'}
                pr={isInternalSticky ? '16px' : '0px'}
                pl={isInternalSticky ? '24px' : '0px'}
                boxShadow={
                    isInternalSticky ? '' : '0 3px 11px 0 rgba(0, 0, 0, 0.32)'
                }
                borderBottomColor={
                    isInternalSticky ? colors.secondary[20] : 'transparent'
                }
                borderBottomWidth="1px"
                borderBottomStyle="solid"
                zIndex={2}
            >
                <div>
                    <Grid layout="fixed">
                        <GridColumn>
                            <View
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <View display="flex" flexDirection="column">
                                    <View pb="12px">
                                        <Text
                                            variant="bodyMd"
                                            fontWeight="700"
                                            lineHeight="18px"
                                            as="div"
                                            data-qa="sticky-title"
                                        >
                                            {title}
                                        </Text>
                                    </View>
                                    <Company
                                        companyName={companyName}
                                        rating={rating}
                                        locationName={locationName}
                                    />
                                </View>
                                <View display="flex" alignItems="right">
                                    <ApplyButtonGroup
                                        handleSaveClick={handleSaveClick}
                                        isSaved={isSaved}
                                        handleCompanyApplyClick={() => {
                                            if (handleCompanyApplyClick) {
                                                handleCompanyApplyClick(
                                                    'sticky-nav'
                                                );
                                            }
                                        }}
                                        position="top"
                                        saveButtonText={saveButtonText}
                                        applyButtonText={applyButtonText}
                                    />
                                </View>
                            </View>
                        </GridColumn>
                    </Grid>
                </div>
            </View>
        </ThemeProvider>
    );
};

export default StickyCompanyHeaderV2;
